import { useGraphql } from "~/api-client";

export function useVoucherCode() {
  const graphql = useGraphql();

  const redeemCode = async (code: string) => {
    const data = await graphql.redeemCode(code);

    if (data.redeemCode.error) {
      throw new Error(data.redeemCode.error.message);
    }

    return data.redeemCode.messageDetails;
  };

  return { redeemCode };
}
